import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[uppercase]'
})
export class UppercaseDirective {
  constructor() {}

  @HostListener('change', ['$event']) onInputChange($event): void {
    $event.target.value = $event.target.value.toUpperCase();
  }
}
